import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { Box, Stack, TextField, Tooltip } from "@mui/material";
import React, { ReactNode, useState } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

export interface IListSearchFilterProp {
    active?: boolean;
    classes?: string;
    inline?: boolean;
    searchFilter: string;
    onSearchClick: (searchFilter: string) => void;
    appendElements?: ReactNode[];
}

interface IListSearchFilterState {
    searchFilter: string;
    executedSearchFilter: string;
}

export const ListSearchFilter = (props: IListSearchFilterProp) => {
    const [state, setState] = useState<IListSearchFilterState>({
        searchFilter: props.searchFilter,
        executedSearchFilter: props.searchFilter
    });

    const handleChange = (event) => {
        setState((old) => ({
            ...old,
            searchFilter: event.target.value
        }));
    };

    const executeSearch = (filter: string) => {
        props.onSearchClick(filter);
        setState((old) => ({
            ...old,
            executedSearchFilter: filter
        }));
    };

    const handleClick = () => {
        executeSearch(state.searchFilter);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleClick();
        }
    };

    const handleClear = () => {
        setState((old) => ({
            ...old,
            searchFilter: ""
        }));
        executeSearch("");
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 2, minWidth: "150px" }}>
            <TextField
                type="text"
                placeholder={Translations.SearchCondition}
                value={state.searchFilter}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                autoFocus
                size="small"
                sx={{ maxWidth: "400px" }}
                fullWidth
                InputProps={{
                    endAdornment: (
                        <>
                            <Tooltip title={Translations.Search}>
                                <AppButton
                                    variant="outlined"
                                    onClick={handleClick}
                                    sx={{ borderRadius: 0, padding: "7px 9px", minWidth: "50px" }}
                                >
                                    <SearchIcon color={state.executedSearchFilter ? "warning" : undefined} />
                                </AppButton>
                            </Tooltip>
                            <Tooltip title={Translations.Clear}>
                                <span>
                                    <AppButton
                                        disabled={!state.executedSearchFilter}
                                        variant="outlined"
                                        onClick={handleClear}
                                        sx={{ marginRight: "-14px", borderRadius: "0 .25rem .25rem 0", padding: "7px 9px", minWidth: "50px" }}
                                    >
                                        <ClearIcon />
                                    </AppButton>
                                </span>
                            </Tooltip>
                        </>
                    )
                }}
            />
            {!!props.appendElements && props.appendElements.length > 0 &&
                <Stack sx={{ marginLeft: "1rem" }}>
                    {props.appendElements.map(element =>
                        element
                    )}
                </Stack>
            }
        </Box>
    );
};